export var ApplyAIStatus;
(function (ApplyAIStatus) {
    ApplyAIStatus["PREPARE_START"] = "PREPARE_START";
    ApplyAIStatus["PREPARE_SUCCESS"] = "PREPARE_SUCCESS";
    ApplyAIStatus["PREPARE_ERROR"] = "PREPARE_ERROR";
    ApplyAIStatus["SEND_START"] = "SEND_START";
    ApplyAIStatus["SEND_SUCCESS"] = "SEND_SUCCESS";
    ApplyAIStatus["SEND_ERROR"] = "SEND_ERROR";
    ApplyAIStatus["APPLY_AI_ERROR"] = "APPLY_AI_ERROR";
    ApplyAIStatus["APPLY_AI_CANCELLED"] = "APPLY_AI_CANCELLED";
    ApplyAIStatus["SUMMARY_COMPLETED"] = "SUMMARY_COMPLETED";
    ApplyAIStatus["SUMMARY_ERROR"] = "SUMMARY_ERROR";
})(ApplyAIStatus || (ApplyAIStatus = {}));
export var ReplayStatus;
(function (ReplayStatus) {
    ReplayStatus["REPLAY_START"] = "REPLAY_START";
    ReplayStatus["REPLAY_SUCCESS"] = "REPLAY_SUCCESS";
    ReplayStatus["REPLAY_ERROR"] = "REPLAY_ERROR";
    ReplayStatus["REPLAY_CANCELLED"] = "REPLAY_CANCELLED";
})(ReplayStatus || (ReplayStatus = {}));
//# sourceMappingURL=Interaction.js.map